import React, { useState } from "react";
import {
  Modal,
  InlineNotification,
} from "@carbon/react";
import "./deleteItemModal.scss";
import { useTranslation } from "react-i18next";
import { queryClient } from "../..";
import { useDeleteRelation } from "../../hooks/useDeleteRelation";
import { useDeleteChat } from "../../hooks/useDeleteChat";

export default function DeleteItemModal({ open, setOpen, type, data }) {
  const [notification, setNotification] = useState({
    visibility: false,
    title: "",
    subtitle: "",
    kind: "",
  });

  const { t } = useTranslation();
  const deleteRelation = useDeleteRelation();
  const deleteChat = useDeleteChat();

  const modalHeading =
    type === "client"
      ? `${t("main.chat.deleteModal.deleteClientHeading", {
          client: data?.client,
          uuid: data?.guid,
        })}`
      : `${t("main.chat.deleteModal.deleteChatHeading", {
          client: data?.client,
          uuid: data?.guid,
          chat: data?.chat,
        })}`;

  const modalPrimaryButton =
    type === "client"
      ? `${t("main.chat.deleteModal.removeSubmitButton")}`
      : `${t("main.chat.deleteModal.deleteSubmitButton")}`;

  const handleDeleteItem = () => {
    if (type === "client") {
      deleteRelation.mutate(
        { guid: data?.guid },
        {
          onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getInfo"] });

            setOpen(false);
          },
          onError: () => {
            setNotification({
              visibility: true,
              title: "authentication.notification.requestError500.title",
              subtitle:
                "authentication.notification.requestError500.serverError",
              kind: "error",
            });
          },
        }
      );
    } else if (type === "chat") {
      deleteChat.mutate(
        { id: data?.id },
        {
          onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["chat_list"] });

            setOpen(false);
          },
          onError: () => {
            setNotification({
              visibility: true,
              title: "authentication.notification.requestError500.title",
              subtitle:
                "authentication.notification.requestError500.serverError",
              kind: "error",
            });
          },
        }
      );
    }
  };

  return (
    <Modal
      open={!!open}
      onRequestClose={() => setOpen(false)}
      size="sm"
      danger
      modalHeading={modalHeading}
      primaryButtonText={modalPrimaryButton}
      secondaryButtonText={`${t("main.chat.addModal.cancel")}`}
      onRequestSubmit={handleDeleteItem}
      onSecondarySubmit={() => setOpen(false)}
      closeButtonLabel={`${t("main.modalText.close")}`}
      className="delete_item"
    >
      {notification.visibility && (
        <InlineNotification
          title={t(notification.title)}
          subtitle={t(notification.subtitle)}
          kind={notification.kind}
          onClose={() =>
            setNotification({
              visibility: false,
              title: "",
              subtitle: "",
              kind: "",
            })
          }
          lowContrast={true}
          aria-label={t("authentication.notification.closeNotification")}
          className="notification"
        />
      )}
    </Modal>
  );
}
